export default "__VITE_ASSET__B9qhEA34__"